import { connect } from 'react-redux'
import { List, WhiteSpace } from 'antd-mobile'
import { Toast } from 'antd-mobile-v5'
import React from 'react'

import { requestMemberRenew } from '../../actions'
import { FormattedMessage } from 'react-intl'
import AppMenus from './AppMenus'
import CoursePicMenu from './CoursePicMenu'
import CourseInsuranceMenu from './CourseInsuranceMenu'
import HonorMenu from './HonorMenu'
import { isMainlandPro } from '../../utils/user'
import { resolveRenewalEntryRoute } from '../../utils/renewalEntry'
import { authedGetService } from '../../services/hooks'
import config from '../../services/config.json'

import './MyProfile.css'
import { useHistory } from 'react-router-dom'

const MemberMenu = ({ profiles }) => {
  const { push } = useHistory()

  const jumpRenewCouponUrl = () => {
    if (isMainlandPro(profiles)) window.location.href = 'https://shop18875151.youzan.com/wscump/coupon/collection'
    else push('/renew_coupons_list')
  }

  // 会员更新入口：已签约自动更新的用户直接进「自动更新」页（查看绑定 / 解除），
  // 未签约或状态没查出来仍进更新选项页（自动更新 / 一次性更新 二选一）。
  const goRenewal = async (accountType) => {
    const service = accountType === 'store' ? config.autoRenewStore : config.autoRenew
    let target
    Toast.show({ icon: 'loading', duration: 0 })
    try {
      const data = await authedGetService(service, {})
      target = resolveRenewalEntryRoute(data, accountType)
    } catch (error) {
      console.error('[MemberMenus] 查询自动更新签约状态失败，进入更新选项页', error)
      target = resolveRenewalEntryRoute(null, accountType)
    } finally {
      Toast.clear()
    }
    push(target)
  }

  if (!profiles.member) return <AppMenus {...profiles} />

  return (
    <>
      <List className="profile-list">
        {profiles.instructorInfo && profiles.instructorInfo.instructorNumber && profiles.isMainlandAddress && (
          <List.Item arrow="horizontal" onClick={() => goRenewal('member')}>
            <FormattedMessage id="renew-member-title" />
          </List.Item>
        )}
        {profiles.storeInfo && profiles.isMainlandAddress && (
          <List.Item arrow="horizontal" onClick={() => goRenewal('store')}>
            <FormattedMessage id="renew-store-title" />
          </List.Item>
        )}
      </List>
      <WhiteSpace size="sm" />

      <List className="profile-list member-renew">
        <List.Item arrow="horizontal" onClick={jumpRenewCouponUrl}>
          <i className="icon fa fa-ticket fa-lg fa-fw"></i>
          <FormattedMessage id="profile-youzan-coupon" />
        </List.Item>

        {/**
         * Resources for member
         */}
        <List.Item arrow="horizontal" onClick={() => (window.location = 'https://pro.padi.com/me/training-hub')}>
          <i className="fa fa-folder-open-o fa-lg fa-fw"></i>
          <FormattedMessage id="resources-training-hub" />
        </List.Item>
        <List.Item arrow="horizontal" onClick={() => (window.location = 'https://pro.padi.com/marketing')}>
          <i className="fa fa-folder-open-o fa-lg fa-fw"></i>
          <FormattedMessage id="resources-marketing-hub" />
        </List.Item>
        {profiles.teachingLocation === 'TW' && (
          <List.Item arrow="horizontal" onClick={() => push('/invoice_form')}>
            發票資訊維護
          </List.Item>
        )}
      </List>

      <WhiteSpace size="sm" />

      {/** 购买签证 */}
      <CoursePicMenu profiles={profiles} />
      <WhiteSpace size="sm" />

      {/** 携保 */}
      {isMainlandPro(profiles) && (
        <CourseInsuranceMenu isStore={profiles.storeInfo} isInstructor={profiles.instructorInfo} />
      )}

      {/** 会员申请 */}
      <AppMenus {...profiles} />
      <WhiteSpace size="sm" />

      {/** 个人荣誉 */}
      <HonorMenu />
      <WhiteSpace size="sm" />
    </>
  )
}

export default connect(null, {
  requestMemberRenew,
})(MemberMenu)
